/**
 * Валідація «Прізвище Імʼя».
 *
 * Жила у ДВОХ ідентичних копіях — `composables/checkout/useCheckoutForm.ts` і
 * локальна функція в `pages/profile.vue`; реєстрація стала б третьою. Винесено
 * сюди, бо правило продуктове, а не формове: за одним словом кур'єрську
 * відправку не оформити, тож усі три форми мусять вимагати те саме.
 */

/** Текст помилки — однаковий скрізь, щоб вимога не виглядала різною. */
export const FULL_NAME_HINT =
  "Введіть у форматі: Прізвище Імʼя (мінімум 2 слова)";

/**
 * Літери укр/лат + апостроф і дефіс. Цифрам і крапкам у ПІБ місця немає.
 *
 * Апострофів ТРИ різновиди, і всі три реальні: `'` (U+0027, звичайна
 * клавіатура), `’` (U+2019, автозаміна в iOS/Word) і `ʼ` (U+02BC — той, що
 * дає українська розкладка, і той, яким написана підказка нижче). Обидві
 * старі копії функції знали лише перші два, тож «Дʼяченко», набране
 * українською розкладкою, форма відхиляла.
 */
const NAME_PART = /^[A-Za-zА-Яа-яІіЇїЄєҐґ'’ʼ-]+$/;

/** "Прізвище Імʼя": мінімум 2 слова по ≥2 літери (укр/лат, апострофи, дефіс). */
export function isFullNameUa(v: unknown): boolean {
  const s = String(v || "")
    .trim()
    .replace(/\s+/g, " ");
  if (!s) return false;
  const parts = s.split(" ");
  if (parts.length < 2) return false;
  return parts.every((p) => p.length >= 2 && NAME_PART.test(p));
}
